import { ReferenceType } from '../../domain/types';

export const referenceTypeMapping: Record<ReferenceType, string> = {
  AGENT: 'agents',
  AGENCY: 'agencies',
  CONTACT: 'contacts',
  INTENT: 'intents',
  JOB_APPLICATION: 'job-applications',
  LEAD: 'leads',
  OFFER: 'offers',
  PROPERTY: 'properties',
  PROSPECT: 'prospects',
  RUMOR: 'rumors',
  SEARCH_CRITERIA: 'search-criteria',
  TASK: 'tasks',
  INVOICE: 'invoices',
  COMPANY: 'companies', // Currently non existent
};
